@if(orgLevel) {
<app-dialog [visible]="visible" [fullscreenOnMobile]="true" class="max-w-xl" (closed)="closeDialog()">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2 px-6 py-4 border-b border-gray-200">
            <div class="text-lg font-bold">Need access to workspace</div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col justify-between h-full px-6 py-4">
            @if(noAccessToShare) {
            <div class="flex flex-col gap-4 justify-between items-center w-full">
                <div class="text-md font-medium ml-2">You don't have access to share with people outside the workspace
                </div>
                <span>Please contact your Workspace Owner or Workspace Admin(s)</span>
            </div>
            } @else {
            <div class="flex flex-col gap-4 justify-between items-center w-full">
                <div class="flex flex-col gap-2 w-full">
                    <div class="flex flex-row justify-between items-center">
                        <div class="text-md font-medium ml-2">Add this user to workspace</div>
                        <app-select [(value)]="selectedPermission" [options]="permissionOptions"
                            [config]="permissionConfig" />
                    </div>
                    <div class="ml-2 mr-2">
                        <div class="flex flex-wrap gap-2 items-center">
                            <div class="flex rounded-base border p-2 gap-2 items-center">
                                <div class="flex gap-2 items-center">
                                    <p-avatar [image]="user | userAvatar" shape="circle"
                                        [style]="{ width: '2rem', height: '2rem' }" />
                                    <div class="flex flex-col">
                                        <p class="text-sm font-medium">{{ user | fullName }}</p>
                                        <p class="text-xs text-gray-500">{{ user.email }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </ng-template>
    @if(!noAccessToShare) {
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" (clicked)="closeDialog()" variant="outlined" severity="contrast" />
            <app-button label="Yes, Share" (clicked)="giveAccessToShareUser()" [enableThrottle]="true"
                variant="filled" severity="primary" />
        </div>
    </ng-template>
    }
</app-dialog>
}

@if(workspaceLevel) {
<app-dialog [visible]="visible" [showCloseButton]="false" [closable]="false" [fullscreenOnMobile]="true"
    class="max-w-[40rem]" (closed)="closeDialog()">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2 px-6 py-4 border-b border-gray-200">
            <div class="text-lg font-bold">Need access to this document</div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 justify-between h-full w-full px-6 py-4">
            <div class="ml-2 mr-2 w-full">
                @if (user) {
                <div class="flex flex-wrap gap-2 items-center mb-2">
                    <div class="flex rounded-base border p-2 gap-2 items-center w-full">
                        <p-avatar [image]="user | userAvatar" shape="circle"
                            [style]="{ width: '2rem', height: '2rem' }" />
                        <div class="flex flex-col">
                            <p class="text-sm font-medium">{{ user | fullName }}</p>
                            <p class="text-xs text-gray-500">{{ user.email }}</p>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div class="flex justify-end gap-2">
                <app-button label="Cancel" (clicked)="closeDialog()" variant="outlined" severity="contrast" />
                <app-button label="Yes, Share" (clicked)="addToShareUser($event)" [enableThrottle]="true"
                    variant="filled" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>
}
